import React, { useEffect, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import Loader from '../utility/Loader';
import styles from './productpage.module.css'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import authservice from '../Authentication/service/authservice';
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import Modal from "react-modal";
import { Button } from 'react-bootstrap';
import mart from '../../assets/mart.png';
import TextDecoration from '../utility/TextDecoration';
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import sty from '../listings/forms/addpost.module.css';
import { validEmailRegex, strongPasswordRegex, usernameRegex, mobilenumberRegex, validateForm } from '../RegxConst'
import ReactPaginate from 'react-paginate';
import SetAdvertiseLocation from "../SetAdvertiseLocation";
import { TermsAndConditions } from "../Authentication/Registration/TermsAndConditions";
import { container, notifyUser, type } from '../utility/notifyUser';
import { error } from "jquery";

const ProductPage = (props) => {
  const { id } = useParams();
  const { martname } = useParams();
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({});
  const [currentIndex, setCurrentIndex] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [martDetails, setMartDetails] = useState(null);
  const [martStatus, setMartStatus] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [cartItems, setCartItems] = useState([]);

  const userNameAvailabilityTimerRef = useRef(null);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [cartMartId, setCartMartId] = useState(localStorage.getItem("cartMartId"));
  const [cartClearing, setCartClearing] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const shareLinkRef = useRef(null);
  const [showInfoPopup, setShowInfoPopup] = useState({});
  const [selectedSizes, setSelectedSizes] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);

  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [contact_number, setContactNumber] = useState('');
  const [email_address, setEmailAddress] = useState('');
  // const [referralKey, setReferralKey] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [checked, setChecked] = useState(false);
  const [radioError, setRadioError] = useState('');
  const [checkError, setCheckError] = useState('');
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState([]);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  // const [termsModel, setTermsModel] = useState(null);
  const [termsModel, setTermsModel] = useState({
    open: false,
    model_type: '',
  });
  const [fullAddress, setFullAddress] = useState([]);
  const selectedState = useRef([]);
  const selectedCity = useRef([]);
  const selectedLocality = useRef([]);
  const selectedNeighbourhood = useRef([]);
  const addressOptions = useRef([]);
  const stateValidation = useRef(null);
  const cityValidation = useRef(null);
  const localityValidation = useRef(null);
  const neighbourhoodValidation = useRef(null);

  const closeModal = () => {
    setTermsModel({
      open: false,
      model_type: '',
    });
  };

  const openModal = (type) => {
    setTermsModel({
      open: true,
      model_type: type,
    });
  }

  useEffect(() => {
    const fetchFullAddress = async () => {
      Loader.runSpinner();
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/getallstates`);
        setFullAddress(response.data);
      } catch (error) {
        console.error('Error fetching address data:', error);
      } finally {
        Loader.stopSpinner();
      }
    };

    fetchFullAddress();
  }, []);


  const _handleState = (selectedStates) => {
    if (selectedStates.length)
      selectedState.current = selectedStates.map(p => p.value);
  }

  const _handleCity = (cities) => {
    if (cities.length)
      selectedCity.current = cities.map(p => p.value);
  };

  const _handleLocality = (localities) => {
    if (localities.length)
      selectedLocality.current = localities.map(p => p.value);
  };

  const _handleNeighbourhood = (neighs) => {
    if (neighs.length)
      selectedNeighbourhood.current = neighs.map(p => p.value);
  };



  const handleSubmit = (event) => {
    event.preventDefault();

    localStorage.setItem('state', selectedState.current[0]);

    localStorage.setItem('city', selectedCity.current[0]);

    localStorage.setItem('locality', selectedLocality.current[0]);

    localStorage.setItem('neighbourhood', selectedNeighbourhood.current[0]);

    if (!checked) {
      setCheckError("Please Check The Check Box to Agree Upon The Terms & Conditions and Privacy Policy.");
    } else {
      setCheckError("");
    }

    // if (!age_checked) {
    //   setAgeCheckError("Please Check The Check Box to Agree Upon The Age above 15.");
    // } else {
    //   setAgeCheckError("");
    // }

    if (checked && validateForm(errors)) {
      const data = {
        userName: username,
        firstName,
        lastName,
        password,
        mobileNumber: contact_number,
        email: email_address,
        referralKey: null,
        stateId: selectedState.current[0],
        cityId: selectedCity.current[0],
        localityId: selectedLocality.current[0],
        neighbourhoodId: selectedNeighbourhood.current[0],
        hasBusiness: false,
        canWriteContent: false,
        canCreateVideo: false,
        canCreatePhoto: false,
        canInfluence: false,
        canDoDigitalMarketing: false,
        canDoPRJournalism: false,
        yearlyAccount: false,
        monthlyPrepaidAccount: false,
        freeAccount: true,
        halfYearlyPrepaidAccount: false,
        noTargetHalfYearlyAccount: false,
        quarterlyPrepaidAccount: false,
      };

      if (selectedState.length < 1) {
        setOpen(true);
        notifyUser("Location", "Select Any State", "danger");
        return;
      }

      else if (cityValidation.current) {
        if (selectedCity.length < 1) {
          setOpen(true);
          notifyUser("Location", "Select Any City", "danger");
          return;
        }

        else if (localityValidation.current) {
          if (selectedLocality.length < 1) {
            setOpen(true);
            notifyUser("Location", "Select Any Locality", "danger");
            return;
          }

          else if (neighbourhoodValidation.current) {
            if (selectedNeighbourhood.length < 1) {
              setOpen(true);
              notifyUser("Location", "Select Any Neighbourhood", "danger");
              return;
            }
            else {
              setOpen(false);
              localStorage.getItem('neighbourhood', selectedNeighbourhood.current[0])
              axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
                Loader.stopSpinner();
                if (response.data)
                  props.history.push('/activation-success/' + props.match.params.verify)
              }).catch(error => {
                if (error.response)
                  notifyUser("Registration", error.response.data, "danger")
              })
            }
          }
          else {
            setOpen(false);
            localStorage.getItem('locality', selectedLocality.current[0])
            axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
              Loader.stopSpinner();
              if (response.data)
                props.history.push('/activation-success/' + props.match.params.verify)
            }).catch(error => {
              if (error.response)
                notifyUser("Registration", error.response.data, "danger")
            })
          }
        }
        else {
          setOpen(false);
          localStorage.getItem('city', selectedCity.current[0])
          axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
            Loader.stopSpinner();
            if (response.data)
              props.history.push('/activation-success/' + props.match.params.verify)
          }).catch(error => {
            if (error.response)
              notifyUser("Registration", error.response.data, "danger")
          })
        }
      }
      else {
        setOpen(false);
        localStorage.getItem('state', selectedState.current[0])
        axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
          Loader.stopSpinner();
          if (response.data)
            props.history.push('/activation-success/' + props.match.params.verify)
        }).catch(error => {
          if (error.response)
            notifyUser("Registration", error.response.data, "danger")
        })
      }
    }


  };

  const handleSizeChange = (productId, selectedSizeObj) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [productId]: selectedSizeObj,
    }));
  };


  const toggleInfoPopup = (productId) => {
    setShowInfoPopup((prev) => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const showShareDialog = () => setIsDialogOpen(true);
  const hideShareDialog = () => setIsDialogOpen(false);

  const copyToClipboard = () => {
    if (shareLinkRef.current) {
      shareLinkRef.current.select();
      document.execCommand('copy');
    }
  };

  const shareTo = (platform) => {
    const businessName = martname.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')
    const baseUrl = `${window.location.origin}/mart/${businessName}/${id}/products}`;
    let url = '';

    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseUrl)}`;
        break;
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(baseUrl)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'skype':
        url = `https://web.skype.com/share?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'snapchat':
        // Snapchat doesn’t support direct link sharing via URL; consider custom integration
        alert("Snapchat sharing not supported directly.");
        return;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'gmail':
        url = `mailto:?subject=Check this out&body=${encodeURIComponent(baseUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
  };

  const businessName = martname.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')

  const shareUrl = `${window.location.origin}/mart/${businessName}/${id}/products`;

  const fetchMartDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartDetails(response.data);
      setModalIsOpen(true);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  const fetchMartOpenDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartDetails(response.data);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  const fetchMartStatusDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartStatus(response.data.open);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  useEffect(() => {
    const initialIndex = {};
    products.forEach((product) => {
      initialIndex[`${product.id}_${product.size}`] = 0;
    });
    setCurrentIndex(initialIndex);
  }, [products]);

  // const handleNext = (productId, totalImages) => {
  //   setCurrentIndex((prev) => ({
  //     ...prev,
  //     [productId]: (prev[productId] + 1) % totalImages,
  //   }));
  // };

  // const handlePrev = (productId, totalImages) => {
  //   setCurrentIndex((prev) => ({
  //     ...prev,
  //     [productId]: (prev[productId] - 1 + totalImages) % totalImages,
  //   }));
  // };

  const handleNext = (productId, size, totalImages) => {
    setCurrentIndex((prev) => {
      const key = `${productId}_${size}`;
      return {
        ...prev,
        [key]: (prev[key] + 1) % totalImages,
      };
    });
  };


  const handlePrev = (productId, size, totalImages) => {
    setCurrentIndex((prev) => {
      const key = `${productId}_${size}`;
      return {
        ...prev,
        [key]: (prev[key] - 1 + totalImages) % totalImages,
      };
    });
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prev) => {
  //       const newIndexes = { ...prev };
  //       products.forEach((product) => {
  //         const totalImages = product.productImages.length;
  //         if (totalImages > 1) {
  //           newIndexes[product.id] = (prev[product.id] + 1) % totalImages;
  //         }
  //       });
  //       return newIndexes;
  //     });
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [products]);

  const handleClearCart = async () => {
    setShowCartModal(false);
    setCartClearing(true);
    setPendingProduct(null);

    const userId = authservice.getCurrentUserid();

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}?paymentMode=PHONEPE`
      );

      if (response.data && response.data.items.length > 0) {
        await Promise.all(
          response.data.items.map(item =>
            axios.delete(
              `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/clear-shopping-bag/${userId}`
            )
          )
        );
      }

      localStorage.removeItem("cart");
      localStorage.setItem("cartMartId", id);
      setCart({});
      setCartMartId(id);

      setTimeout(() => {
        setCartClearing(false);
        if (pendingProduct) {
          //addToCart(pendingProduct.product);
          setPendingProduct(null);
        }
      }, 300);
    } catch (error) {
      console.error("❌ Error clearing cart:", error);
      setCartClearing(false);
    }
  };

  const selectedProducts = useMemo(() => {
    return selectedCategory ? products.filter(p => p.productCategory === selectedCategory) : products;
  }, [selectedCategory, products]);

  // const remainingProducts = useMemo(() => {
  //   return selectedCategory ? products.filter(p => p.productCategory !== selectedCategory) : products;
  // }, [products]);

  // const remainingProducts = products.reduce((acc, product) => {
  //   if (!acc[product.productId]) {
  //     acc[product.productId] = {
  //       ...product,
  //       sizes: [],
  //     };
  //   }
  //   acc[product.productId].sizes.push({
  //     size: product.size,
  //     price: product.price,
  //     stock: product.stock,
  //   });
  //   return acc;
  // }, {});

  // const remainingProductsList = Object.values(remainingProducts);


  useEffect(() => {
    fetchMartOpenDetails()
    fetchMartStatusDetails()
    fetchProducts(0);
    if (authservice.getCurrentUserid() !== null)
      fetchCart()
    window.scroll(0, 0)
  }, []);

  const fetchProducts = async (page = 0) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/v2/get-published-products/${id}?page=${page}`);
      const formattedProducts = response.data.data.flatMap(product =>
        product.sizeStockPrices.map(sizeData => ({
          ...product,
          size: sizeData.size,
          price: sizeData.productPrice,
          remainingStock: sizeData.stockQuantity,
          available: product.available,
          availableFrom: product.availableFrom,
          availableTo: product.availableTo,
          productImage: product.productImages[0] || "default-image.jpg"
        }))
      );
      setProducts(formattedProducts);

      setCurrentPage(page);
      setPageCount(response.data.pageCount || 1);

      const uniqueCategories = [...new Set(response.data.data.map(p => p.productCategory))];
      setCategories(uniqueCategories);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    fetchProducts(selectedPage); // fetch products for that page
  };

  const fetchCart = async () => {
    const userId = authservice.getCurrentUserid();
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}?paymentMode=PHONEPE`);
      setCartItems(response.data.items || []);
      const cartData = {};

      response.data.items.forEach((item) => {
        //const productKey = `${item.size}-${item.productId}`;
        cartData[item.size + item.productId] = item.quantity;
      });
      setCart(cartData);
      localStorage.setItem("cart", JSON.stringify(cartData)); // Sync local storage
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  // const handleAddToCart = async (product) => {
  //   if (showCartModal) return;
  //   const userId = authservice.getCurrentUserid();
  //   const currentMartId = id;

  //   const quantity = 1;
  //   if (authservice.getCurrentUserid() === null)
  //     setShowLoginModal(true)
  //   else {
  //     if (cartMartId && cartMartId !== currentMartId) {
  //       setPendingProduct({ product, size: product.size, quantity });
  //       setShowCartModal(true);
  //       return;
  //     }
  //   }
  //   axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
  //     null,
  //     {
  //       params: { productId: product.id, size: product.size, quantity, paymentMode: "PHONEPE" },
  //     }).then(() => {
  //       setCart((prevCart) => {
  //         const updatedCart = { ...prevCart, [product.size + product.id]: quantity }
  //         localStorage.setItem("cart", JSON.stringify(updatedCart));
  //         localStorage.setItem("cartMartId", currentMartId);
  //         setCartMartId(currentMartId);
  //         return updatedCart;
  //       });

  //       fetchCart();
  //     }).catch((error) => console.error("Error adding to cart:", error))
  // };


  const handleAddToCart = async (product, selectedSizeObj) => {
    if (showCartModal) return;

    const userId = authservice.getCurrentUserid();
    const currentMartId = id;
    const quantity = 1;

    if (!userId) {
      setShowLoginModal(true);
      return;
    }

    const size = selectedSizeObj.size;
    const cartKey = size + product.id;

    if (cartMartId && cartMartId !== currentMartId) {
      // Cart conflict - from different mart
      setPendingProduct({ product, size, quantity });
      setShowCartModal(true);
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
        null,
        {
          params: {
            productId: product.id,
            size,
            quantity,
            paymentMode: "PHONEPE",
          },
        }
      );

      // Update cart in state and localStorage
      setCart((prevCart) => {
        const existingQty = prevCart[cartKey] || 0;
        const updatedCart = {
          ...prevCart,
          [cartKey]: existingQty + 1,
        };
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        localStorage.setItem("cartMartId", currentMartId);
        setCartMartId(currentMartId);
        return updatedCart;
      });

      fetchCart(); // refresh cart from backend
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };


  // const handleIncreaseQuantity = async (product) => {
  //   console.log("Product object:", product);
  //   const userId = authservice.getCurrentUserid();
  //   const currentMartId = id;

  //   if (!product.id || !product.size) {
  //     console.error("Error: productId or size is missing!", product);
  //     return;
  //   }

  //   setCart((prevCart) => {
  //     const currentQuantity = prevCart[product.size + product.id] || 0;
  //     const newQuantity = currentQuantity + 1;

  //     const updatedCart = { ...prevCart, [product.size + product.id]: newQuantity };
  //     localStorage.setItem("cart", JSON.stringify(updatedCart));
  //     localStorage.setItem("cartMartId", currentMartId);
  //     setCartMartId(currentMartId);

  //     return updatedCart;
  //   });

  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
  //       null, // No body, only params
  //       {
  //         params: {
  //           productId: product.id,
  //           size: product.size,
  //           quantity: cart[product.size + product.id] + 1 || 1, // Ensure correct quantity
  //           paymentMode: "PHONEPE"
  //         },
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //     // fetchCart(); // Refresh cart after successful API request
  //   } catch (error) {
  //     console.error("Error increasing quantity:", error);
  //   }
  // };

  const handleIncreaseQuantity = async (product, selectedSizeObj) => {
    const userId = authservice.getCurrentUserid();
    const currentMartId = id;

    if (!userId) {
      setShowLoginModal(true);
      return;
    }

    const size = selectedSizeObj.size;
    const cartKey = size + product.id;

    if (!size || !product.id) {
      console.error("Error: productId or size is missing!", { size, productId: product.id });
      return;
    }

    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ product, size, quantity: 1 });
      setShowCartModal(true);
      return;
    }

    const currentQuantity = cart[cartKey] || 0;
    const newQuantity = currentQuantity + 1;

    setCart((prevCart) => {
      const updatedCart = {
        ...prevCart,
        [cartKey]: newQuantity,
      };
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      localStorage.setItem("cartMartId", currentMartId);
      setCartMartId(currentMartId);
      return updatedCart;
    });

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
        null,
        {
          params: {
            productId: product.id,
            size,
            quantity: newQuantity,
            paymentMode: "PHONEPE",
          },
          headers: { "Content-Type": "application/json" },
        }
      );
      // fetchCart(); // Optional if needed
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };


  // const handleDecresaeQuantity = async (product) => {
  //   console.log("Product object:", product);
  //   const userId = authservice.getCurrentUserid();
  //   const currentMartId = id;

  //   if (!product.id || !product.size) {
  //     console.error("Error: productId or size is missing!", product);
  //     return;
  //   }

  //   setCart((prevCart) => {
  //     const currentQuantity = prevCart[product.size + product.id] || 0;
  //     const newQuantity = currentQuantity - 1;

  //     const updatedCart = { ...prevCart, [product.size + product.id]: newQuantity };
  //     localStorage.setItem("cart", JSON.stringify(updatedCart));
  //     localStorage.setItem("cartMartId", currentMartId);
  //     setCartMartId(currentMartId);

  //     return updatedCart;
  //   });

  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
  //       null, // No body, only params
  //       {
  //         params: {
  //           productId: product.id,
  //           size: product.size,
  //           quantity: cart[product.size + product.id] - 1 || 0,
  //           paymentMode: "PHONEPE"
  //         },
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Error increasing quantity:", error);
  //   }
  // };

  const handleDecresaeQuantity = async (product, selectedSizeObj) => {
    const userId = authservice.getCurrentUserid();
    const currentMartId = id;

    if (!userId) {
      setShowLoginModal(true);
      return;
    }

    const size = selectedSizeObj.size;
    const cartKey = size + product.id;

    if (!size || !product.id) {
      console.error("Error: productId or size is missing!", { size, productId: product.id });
      return;
    }

    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ product, size, quantity: 1 });
      setShowCartModal(true);
      return;
    }

    const currentQuantity = cart[cartKey] || 0;
    const newQuantity = Math.max(currentQuantity - 1, 0); // prevent negative quantity

    // If quantity is 0, remove it from cart
    setCart((prevCart) => {
      const updatedCart = { ...prevCart };
      if (newQuantity === 0) {
        delete updatedCart[cartKey];
      } else {
        updatedCart[cartKey] = newQuantity;
      }

      localStorage.setItem("cart", JSON.stringify(updatedCart));
      localStorage.setItem("cartMartId", currentMartId);
      setCartMartId(currentMartId);

      return updatedCart;
    });

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
        null,
        {
          params: {
            productId: product.id,
            size,
            quantity: newQuantity,
            paymentMode: "PHONEPE",
          },
          headers: { "Content-Type": "application/json" },
        }
      );
    } catch (error) {
      console.error("Error decreasing quantity:", error);
    }
  };


  const redirect = (url) => {
    if (url) {
      const fixedUrl = url.startsWith("http://") || url.startsWith("https://")
        ? url
        : `https://${url}`;
      window.open(fixedUrl, "_blank");
    }
  };

  // const uniqueProducts = Array.from(
  //   new Map(remainingProducts.map((p) => [p.id, p])).values()
  // );

  const uniqueProductsSelected = Array.from(
    new Map(selectedProducts.map((p) => [p.id, p])).values()
  );

  const handleUserName = (e) => {
    e.preventDefault();
    if (userNameAvailabilityTimerRef.current) clearTimeout(userNameAvailabilityTimerRef.current);
    const userNameInput = e.target.value;
    setUsername(userNameInput);
    const updatedErrors = { ...errors };
    userNameAvailabilityTimerRef.current = setTimeout(async () => {
      if (userNameInput.length > 3 && userNameInput.length < 16) {
        if (usernameRegex.test(userNameInput)) {
          try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/auth/checkusername?userName=${userNameInput}`);
            updatedErrors.username = response.data;
          } catch (error) {
            updatedErrors.username = 'Error checking username availability';
          }
        } else {
          updatedErrors.username = 'Username contains invalid characters';
        }
      } else {
        updatedErrors.username = userNameInput.length < 4 ? 'Username should be minimum of 4 characters' : 'Too long username';
      }
      setErrors(updatedErrors);
    }, 1000);
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let updatedErrors = errors;
    if (value) {
      switch (name) {
        case 'email_address': {
          errors.email_address =
            validEmailRegex.test(value)
              ? ''
              : 'Email is Not Valid!';
          break;
        }
        case 'password': {
          if (value.length < 8)
            errors.password = 'Password should be minimum of 8 characters and must contain atleast 1 Lowercase , 1 Uppercase , 1 Numeric and 1 Special Character'
          else
            errors.password = strongPasswordRegex.test(value)
              ? ""
              : 'Password Must Contain at Least 1 Lowercase or 1 Uppercase , 1 Numeric and 1 Special Character';
          errors.confirmpassword = confirmpassword && value !== confirmpassword ? 'Password Does Not Match' : ""
          break;
        }
        case 'confirmpassword':
          errors.confirmpassword = (value === password ? '' : 'Password Does Not Match');
          break;
        case 'contact_number': {
          errors.contact_number =
            mobilenumberRegex.test(value)
              ? (value.length < 10)
                ? 'Mobile Number Must Have 10 Digits'
                : ''
              : 'Invalid Mobile Number (Hint: Do not enter STD/ISO code)'
          break;
        }
        default:
          break;
      }
      setErrors(updatedErrors);
    } else {
      errors[name] = '';
    }
  }

  let weeklyHours = [];

  if (martDetails && martDetails.openingHoursList) {
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    weeklyHours = days.map((day) => {
      const entry = martDetails.openingHoursList.find(
        (item) => item.day.toLowerCase() === day
      );
      return {
        day: day.charAt(0).toUpperCase() + day.slice(1),
        opening: entry ? entry.openingTime : "Closed",
        closing: entry ? entry.closingTime : "Closed",
      };
    });
  }



  return (
    <div className={styles.admin_view_head}>
      <div className={`col-md-2 add_button animated_back_button text-right d-none d-md-block ${styles.bckBtn}`}>
        <ButtonStyle type="button" className="form-control btn btn-block btn_font"
          handleClick={() => props.history.push("/mart")}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
      </div>
      {martStatus === false ? (
        <>
          <div className={styles.martClosedContainer}>
            <img
              src={mart} // Replace with actual path
              alt="Mart Closed"
              className={styles.martClosedGif}
            />
          </div>
          <div className={styles.hoursTableContainer}>
          {weeklyHours.length > 0 ? (
            <table className={styles.hoursTable}>
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Opening Time</th>
                  <th>Closing Time</th>
                </tr>
              </thead>
              <tbody>
                {weeklyHours.map((h, index) => (
                  <tr key={index}>
                    <td>{h.day}</td>
                    <td>{h.opening}</td>
                    <td>{h.closing}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>Loading hours...</p>
          )}
          </div>
        </>
      ) : (
        <>
          <Modal isOpen={showCartModal} onRequestClose={() => setShowCartModal(false)}
            className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <div className={styles.martDetails}>
              <h3 className={styles.product_name}>Clear Cart?</h3>
              <p><strong>You already have products from a different mart. Do you want to clear your cart and add this product?</strong></p>
              <div className={styles.modalButtons}>
                <Button variant="danger" className="secondary" onClick={handleClearCart} disabled={cartClearing}>
                  {cartClearing ? "Clearing..." : "Yes, Clear Cart"}
                </Button>&nbsp;
                <Button className="secondary" variant="secondary" onClick={() => setShowCartModal(false)}>No</Button>
              </div>
            </div>
          </Modal>
          <Modal isOpen={showLoginModal} onRequestClose={() => setShowLoginModal(false)}
            className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <div className={styles.martDetails}>
              <h3 className={styles.product_name}>Add To Cart?</h3>
              <p><strong>To add this product in the cart, you have to <span
                type="button"
                style={{ color: 'navy' }}
                onClick={() => setShowRegistrationModal(true)}
              >
                Register
              </span> or <Link style={{ color: 'navy' }} to="/login/user">login</Link>  your account.</strong></p>
              <div className={styles.modalButtons}>
                <Button className="secondary" variant="secondary" onClick={() => setShowLoginModal(false)}>No</Button>
              </div>
            </div>
          </Modal>
          <Modal isOpen={showRegistrationModal} onRequestClose={() => setShowRegistrationModal(false)} className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <Button variant="danger" onClick={() => setShowRegistrationModal(false)} className="popup-close-btn">&times;</Button>
            <TermsAndConditions closeModal={closeModal} terms={termsModel} />
            <form onSubmit={handleSubmit}>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label} col-form-label`} htmlFor="title">Name*</label>
                </div>
                <div className="col-12 col-md-8 pb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    name="firstName"
                    required
                    value={firstName}
                    noValidate
                    onChange={(e) => setFirstName(e.target.value)}
                    onInput={handleChange}
                  />
                </div>
                <div className="col-12 col-md-4"></div>
                <div className="col-12 col-md-8">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    name="lastName"
                    required
                    value={lastName}
                    noValidate
                    onChange={(e) => setLastName(e.target.value)}
                    onInput={handleChange}
                  />
                </div>
              </div>

              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="title">User name*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input type="text" className="form-control" placeholder="User name"
                    name="username" required value={username} noValidate autoComplete="new-password"
                    onChange={(e) => setUsername(e.target.value)}
                    onInput={handleUserName}
                  />
                  {errors.username && <div className="text-danger">{errors.username}</div>}
                </div>
              </div>


              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Password*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input type="password" className="form-control" placeholder="Password"
                    name="password" autoComplete="new-password" required
                    value={password} noValidate
                    onChange={(e) => setPassword(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.password && <div className="text-danger">{errors.password}</div>}

                </div>
              </div>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="title">Confirm password*</label></div>
                <div className="col-12 col-md-8">
                  <input type="password" className="form-control" placeholder="Confirm password"
                    name="confirmpassword" required value={confirmpassword} noValidate
                    onChange={(e) => setConfirmpassword(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.confirmpassword && <div className="text-danger">{errors.confirmpassword}</div>}

                </div>
              </div>

              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Mobile number*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input className="form-control" placeholder="Mobile number" noValidate maxLength="10"
                    name="contact_number" required value={contact_number}
                    onChange={(e) => setContactNumber(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.contact_number && <div className="text-danger">{errors.contact_number}</div>}

                </div>
              </div>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Email address*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input className="form-control" placeholder="Email address" name="email_address"
                    required value={email_address} noValidate
                    onChange={(e) => setEmailAddress(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.email_address && <div className="text-danger">{errors.email_address}</div>}
                </div>
              </div>
              {/* <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Invitation key</label></div>
                <div className="col-12 col-md-8">
                  <input className="form-control" placeholder="Enter invitation key"
                    name="referralKey" value={referralKey} noValidate
                    onChange={(e) => setReferralKey(e.target.value)}
                  />
                </div>
              </div> */}
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Location*</label>
                </div>
                {/* <div className="col-12 col-md-4"></div> */}

                <div className="col-12 col-md-8">
                  <SetAdvertiseLocation
                    setFilterValidationMethod={props.setLocationValidationMethod}
                    allLocations={fullAddress}
                    selectedStates={selectedState.current}
                    selectedCities={selectedCity.current}
                    selectedLocalities={selectedLocality.current}
                    selectedNeighbourhoods={selectedNeighbourhood.current}
                    _handleState={_handleState}
                    _handleCity={_handleCity}
                    _handleLocality={_handleLocality}
                    _handleNeighbourhood={_handleNeighbourhood}
                    addressOptions={addressOptions.current}
                    setAddressOptions={(opts) => { addressOptions.current = opts; }}
                    labelClass="col-md-8"
                    setStateValidationMethod={(m) => { stateValidation.current = m; }}
                    setCityValidationMethod={(m) => { cityValidation.current = m; }}
                    setLocalityValidationMethod={(m) => { localityValidation.current = m; }}
                    setNeighbourhoodValidationMethod={(m) => { neighbourhoodValidation.current = m; }}
                  />
                </div>
              </div>
              <p>Tell us your location to see what is near you. (If your location is not available, please select your nearest location.)</p>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
                <label className="form-check-label">I have read and understood the&nbsp;
                  <span style={{ color: 'navy' }} type='button' onClick={() => { openModal('terms') }}>Terms &amp; Conditions,</span> and agree.</label>
              </div>
              {checkError && <div className="text-danger mb-2">{checkError}</div>}
              <div className="form-group row justify-content-center">
                <div className="col-12 text-center">
                 <ButtonStyle type="submit" className="btn" text={'Submit'} />
                </div>
              </div>
            </form>
          </Modal>
          <div className={`col-md-3 ${styles.cartButtonContainer} d-none d-md-flex m-5`}>
            <Link style={{ color: "#fff", backgroundColor: '#FF9933' }} type="button" className={`form-control btn btn-block ${styles.btn_font_share}`} to="/mart/product/cart">🛒 Go to Cart</Link>

            <i className={`${styles.infoIcon} fas fa-info-circle`} onClick={fetchMartDetails}>
              {/* <i className='fas fa-info-circle'></i> */}
            </i>
            <Link style={{ color: "#fff", backgroundColor: '#FF9933' }} type="button" className={`form-control btn btn-block ${styles.btn_font_share}`} onClick={showShareDialog}>
              Share
            </Link>
          </div>
          <div className={`row d-md-none ${styles.headerIcons}`}>
            <div className={`col-md-3 ${styles.leftIcon}`} style={{ width: '20%' }}>
              <button style={{ color: '#fff' }} type="button" className={`btn btn-block ${styles.backIcon}`}
                handleClick={() => props.history.push("/mart")}>Back </button>
            </div>&nbsp;
            <div className="col-md-6" style={{ width: '75%' }}>
              <div className={`row ${styles.rightIcon}`}>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <Link type="button" className={`btn btn-block ${styles.btn_font_cart_mob}`} to="/mart/product/cart">🛒</Link>
                </div>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <div className={`${styles.infoIcon} fas fa-info-circle`} onClick={fetchMartDetails}>i</div>
                </div>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <Link style={{ color: '#fff' }} type="button" className={`btn btn-block ${styles.btn_font_share_mob}`} onClick={showShareDialog}><i class="fa fa-share-alt"></i></Link>
                </div>
              </div>
            </div>
          </div>
          {isDialogOpen && (
            <div className="sharedialog">
              <h2>Share this Clip</h2>
              <input
                type="text"
                value={shareUrl}
                ref={shareLinkRef}
                style={{ width: '80%', padding: '5px', marginBottom: '10px' }}
                readOnly
              />
              <button className="copylink" onClick={copyToClipboard}>
                <i className="fa fa-copy"></i>
              </button>
              <div className="sharebuttons">
                <div className="sharebutton fb" onClick={() => shareTo('facebook')}></div>
                <div className="sharebutton whatsapp" onClick={() => shareTo('whatsapp')}></div>
                <div className="sharebutton twitter" onClick={() => shareTo('twitter')}></div>
                <div className="sharebutton skype" onClick={() => shareTo('skype')}></div>
                <div className="sharebutton telegram" onClick={() => shareTo('telegram')}></div>
                <div className="sharebutton snapchat" onClick={() => shareTo('snapchat')}></div>
                <div className="sharebutton linkedin" onClick={() => shareTo('linkedin')}></div>
                <div className="sharebutton gmail" onClick={() => shareTo('gmail')}></div>
              </div>
              <button className="shareclose" onClick={hideShareDialog}>
                Close
              </button>
            </div>
          )}
          <div className={`row ${styles.filterContainer}`}>
            <label className={styles.filterLabel}>Select Category: &nbsp;
              <span className={styles.dropdown} onClick={() => setDropdownOpen(!dropdownOpen)}>
                <span className={styles.dropdownSelected}>
                  {selectedCategory || "All Categories"}
                </span>
                {dropdownOpen && (
                  <ul className={styles.dropdownList}>
                    <li
                      className={styles.dropdownItem}
                      onClick={() => { setSelectedCategory(""); setDropdownOpen(false); }}
                    >
                      All
                    </li>
                    {categories.map((category, index) => (
                      <li
                        key={index}
                        className={`${styles.dropdownItem} ${selectedCategory === category ? styles.active : ""}`}
                        onClick={() => { setSelectedCategory(category); setDropdownOpen(false); }}
                      >
                        {category}
                      </li>
                    ))}
                  </ul>
                )}
              </span>
            </label>
          </div>


          {selectedProducts.length > 0 && (
            <>
              <h3 className={styles.subheading}>Products</h3>
              <div className="row">
                {uniqueProductsSelected.map((product) => {
                  const cartItem = cartItems.find((item) => item.productId === product.productId && item.size === product.size);
                  if (!product.sizeStockPrices || product.sizeStockPrices.length === 0)
                    return null;
                  const selected =
                    selectedSizes[product.id] || product.sizeStockPrices[0];
                  const size = selected && selected.size ? selected.size : '';
                  const cartKey = size + product.id;
                  return (
                    <div key={product.productId} className={`col-6 col-sm-4 col-lg-3 col-xl-2 col-xxl-2 ${styles.low_padding}`}>
                      <div className={styles.listing_card_video} style={{ opacity: product.available ? 1 : 0.5 }}>
                        <div className={styles.carousel_container}>
                          {product.productImages.length > 1 && (
                            <>
                              <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                              </a>
                              <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                              </a>
                            </>
                          )}
                          <div className={styles.listing_thumb_image_video}>
                            <img
                              src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                              alt="Product"
                              className={styles.product_img}
                            />
                          </div>
                        </div>
                        <div className={styles.listing_details}>
                          <h3 className={styles.product_name}>{product.productName}</h3>
                          <div className={styles.listing_address}>
                            <p><span className={`d-md-block d-none ${styles.stock}`}>Size: &nbsp;
                              <select
                                value={selected.size}
                                onChange={(e) => {
                                  const selectedObj = product.sizeStockPrices.find(
                                    (s) => s.size === e.target.value
                                  );
                                  handleSizeChange(product.id, selectedObj);
                                }}
                              >
                                {product.sizeStockPrices.map((s) => (
                                  <option key={s.size} value={s.size}>
                                    {s.size}
                                  </option>
                                ))}
                              </select><br></br>
                              <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                              Stock: {product.remainingStock}</span>
                              <span className={styles.website} onClick={() => toggleInfoPopup(product.id)}>Product Description</span><br></br>
                            </p>
                            <div className="d-flex justify-content-center">
                              <div className={styles.quantity_container}>
                                <i className={`${styles.info_btn} fas fa-info-circle`} onClick={() => toggleInfoPopup(product.id)}></i>
                              </div>
                              {/* {cart[cartKey] ? (
                                <div className={styles.quantity_container}>
                                  <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>
                                    -
                                  </button>
                                  <span className={styles.quantity}>{cart[cartKey]}</span>
                                  <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>
                                    +
                                  </button>
                                </div>
                              ) : (
                                <div className={styles.quantity_container}>
                                  <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>
                                    Add to Cart
                                  </button>
                                </div>
                              )} */}
                              {product.available === true ? (
                                cart[cartKey] ? (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>-</button>
                                    <span className={styles.quantity}>{cart[cartKey]}</span>
                                    <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>+</button>
                                  </div>
                                ) : (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>
                                      Add to Cart
                                    </button>
                                  </div>
                                )
                              ) : (
                                <div className={styles.quantity_container}>
                                  <span style={{ color: 'red', fontSize: '13px', fontWeight: 500 }}>
                                    Next available from {product.availableFrom} to {product.availableTo}
                                  </span>
                                </div>
                              )}

                            </div>
                          </div>
                        </div>

                      </div>
                      {showInfoPopup[product.id] && (
                        <div className={styles.popup_overlay}>
                          <div className={styles.popup}>
                            <button className={styles.close_popup} onClick={() => toggleInfoPopup(product.id)}>X</button>
                            <div className={`${styles.carousel_container}`}>
                              {product.productImages.length > 1 && (
                                <>
                                  <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                                    <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                                  </a>
                                  <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                                    <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                                  </a>
                                </>
                              )}
                              <div className={styles.listing_thumb_image_video}>
                                <img
                                  src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                                  alt="Product"
                                  className={styles.popup_image}
                                />
                              </div>
                            </div>
                            <h3>{product.productName}</h3>
                            <p>{product.productDescription}</p>
                            <p className={styles.stockPopup}>Size: &nbsp;
                              <select
                                value={selected.size}
                                onChange={(e) => {
                                  const selectedObj = product.sizeStockPrices.find(
                                    (s) => s.size === e.target.value
                                  );
                                  handleSizeChange(product.id, selectedObj);
                                }}
                              >
                                {product.sizeStockPrices.map((s) => (
                                  <option key={s.size} value={s.size}>
                                    {s.size}
                                  </option>
                                ))}
                              </select><br></br>
                              <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                              Stock: {product.remainingStock}<br></br>
                              <span className={styles.website} onClick={() => redirect(product.webSite)}>{product.webSite ? <b>More Info</b> : null}</span>
                            </p>
                            <div className="d-flex justify-content-center">
                              <div className={styles.quantity_container}>
                                <button className={styles.add_to_cart} onClick={() => toggleInfoPopup(product.id)}>
                                  Close
                                </button>
                              </div> &nbsp;
                              {/* {cart[cartKey] ? (
                                <div className={styles.quantity_container}>
                                  <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>-</button>
                                  <span className={styles.quantity}>{cart[cartKey]}</span>
                                  <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>+</button>
                                </div>
                              ) : (
                                <div className={styles.quantity_container}>
                                  <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>Add to Cart</button>
                                </div>
                              )} */}
                              {product.available ? (
                                cart[cartKey] ? (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>-</button>
                                    <span className={styles.quantity}>{cart[cartKey]}</span>
                                    <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>+</button>
                                  </div>
                                ) : (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>
                                      Add to Cart
                                    </button>
                                  </div>
                                )
                              ) : (
                                <div className={styles.quantity_container}>
                                  <span style={{ color: 'red', fontSize: '13px', fontWeight: 500 }}>
                                    Next available from {product.availableFrom} to {product.availableTo}
                                  </span>
                                </div>
                              )}

                            </div>
                          </div>
                        </div>
                      )}
                    </div>)
                })}
              </div>
              {pageCount > 1 && (
                <div className="pagination-container text-center">
                  <ReactPaginate
                    previousLabel={"← Prev"}
                    nextLabel={"Next →"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    forcePage={currentPage}
                    disabledClassName="pagination_disable_next_prev"
                  />
                </div>
              )}
            </>
          )}

          {/* <h3 className={styles.subheading}>All Products</h3>
          <div className="row">
            {uniqueProducts.map((product) => {
              const cartItem = cartItems.find((item) => item.productId === product.productId && item.size === product.size);
              if (!product.sizeStockPrices || product.sizeStockPrices.length === 0)
                return null;
              const selected =
                selectedSizes[product.id] || product.sizeStockPrices[0];
              const size = selected && selected.size ? selected.size : '';
              const cartKey = size + product.id;

              return (
                <div key={product.productId} className={`col-6 col-sm-4 col-lg-3 col-xl-2 col-xxl-2 ${styles.low_padding}`}>
                  <div className={styles.listing_card_video}>
                    <div className={`${styles.carousel_container}`}>
                      {product.productImages.length > 1 && (
                        <>
                          <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                            <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                          </a>
                          <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                            <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                          </a>
                        </>
                      )}
                      <div className={styles.listing_thumb_image_video}>
                        <img
                          src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                          alt="Product"
                          className={styles.product_img}
                        />
                      </div>
                    </div>
                    <div className={styles.listing_details}>
                      <h3 className={styles.product_name}>{product.productName}</h3>
                      <div className={` ${styles.listing_address}`}>
                        <p><span className={`d-md-block d-none ${styles.stock}`}>Size: &nbsp;
                          <select
                            value={selected.size}
                            onChange={(e) => {
                              const selectedObj = product.sizeStockPrices.find(
                                (s) => s.size === e.target.value
                              );
                              handleSizeChange(product.id, selectedObj);
                            }}
                          >
                            {product.sizeStockPrices.map((s) => (
                              <option key={s.size} value={s.size}>
                                {s.size}
                              </option>
                            ))}
                          </select><br></br>
                          <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                          Stock: {product.remainingStock}</span>
                          <span className={styles.website} onClick={() => toggleInfoPopup(product.id)}>Product Description</span><br></br>
                        </p>

                        <div className="d-flex justify-content-center">
                          {cart[cartKey] ? (
                            <div className={styles.quantity_container}>
                              <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>
                                -
                              </button>
                              <span className={styles.quantity}>{cart[cartKey]}</span>
                              <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>
                                +
                              </button>
                            </div>
                          ) : (
                            // <div className={styles.quantity_container}>
                            <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>
                              Add to Cart
                            </button>
                            // </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {showInfoPopup[product.id] && (
                    <div className={styles.popup_overlay}>
                      <div className={styles.popup}>
                        <button className={styles.close_popup} onClick={() => toggleInfoPopup(product.id)}>X</button>
                        <div className={`${styles.carousel_container}`}>
                          {product.productImages.length > 1 && (
                            <>
                              <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                              </a>
                              <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                              </a>
                            </>
                          )}
                          <div className={styles.listing_thumb_image_video}>
                            <img
                              src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                              alt="Product"
                              className={styles.popup_image}
                            />
                          </div>
                        </div>
                        <h3>{product.productName}</h3>
                        <p>{product.productDescription}</p>
                        <p className={styles.stockPopup}>Size: &nbsp;
                          <select
                            value={selected.size}
                            onChange={(e) => {
                              const selectedObj = product.sizeStockPrices.find(
                                (s) => s.size === e.target.value
                              );
                              handleSizeChange(product.id, selectedObj);
                            }}
                          >
                            {product.sizeStockPrices.map((s) => (
                              <option key={s.size} value={s.size}>
                                {s.size}
                              </option>
                            ))}
                          </select><br></br>
                          <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                          Stock: {product.remainingStock}<br></br>
                          <span className={styles.website} onClick={() => redirect(product.webSite)}>{product.webSite ? <b>More Info</b> : null}</span>
                        </p>
                        <div className="d-flex justify-content-center">
                          <div className={styles.quantity_container}>
                            <button className={styles.add_to_cart} onClick={() => toggleInfoPopup(product.id)}>
                              Close
                            </button>
                          </div> &nbsp;
                          {cart[cartKey] ? (
                            <div className={styles.quantity_container}>
                              <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>-</button>
                              <span className={styles.quantity}>{cart[cartKey]}</span>
                              <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>+</button>
                            </div>
                          ) : (
                            <div className={styles.quantity_container}>
                              <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>Add to Cart</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              )
            })}
          </div> */}

          {/* </div> */}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            className={styles.modalContent}
            overlayClassName={styles.modalOverlay}
          >
            <Button variant="danger" className="popup-close-btn" onClick={() => setModalIsOpen(false)}>
              &times;
            </Button>
            {martDetails && (
              <div className={styles.martDetails}>
                <img
                  src={`${process.env.REACT_APP_IMAGES_URL}${martDetails.thumbnailImage}`}
                  alt="Mart Thumbnail"
                  className={styles.martImage}
                />
                <h2 className={styles.product_name}>{martDetails.martName}</h2>
                <p>{martDetails.businessDescription}</p>
                <p><strong>Address:</strong> {martDetails.businessAddress}</p>
                <p><strong>Contact Person:</strong> {martDetails.contactName}</p>
                <p><strong>Contact Number:</strong> {martDetails.contactNumber}</p>
                {/* <p><strong>Home Delivery: </strong> {martDetails.homeDeliveryAvailable ? 'Yes' : 'No'} </p>
                <p><strong>Pickup Available: </strong> {martDetails.pickupAvailable ? 'Yes' : 'No'} </p> */}
                <p><strong>Mart Open: </strong> {martDetails.open ? 'Yes' : 'No'} </p>
                <Button className="secondary" variant="secondary" onClick={() => setModalIsOpen(false)}>
                  Cancel
                </Button>
              </div>
            )}
          </Modal>
        </>
      )}<br></br>
      <div className={`listings row ${sty.large_rect}`}>
        {!props.isAdmin && <LargeRectangle spot={"-1"} />}
      </div>
      <div className={`${sty.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
        {!props.isAdmin && <BillBoard spot={"-1"} />}
      </div>
    </div>
  );
};

export default ProductPage;
